module.exports = [
  // type
  require('./ResultSet')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/resultset/index.js
// module id = 959
// module chunks = 0